export interface IndexedLine {
  character: string
  episodeId: string
  id: string
  quote: string
  tags: string[]
  highlight?: string
}

export interface Episode {
  id: string
  season: string
  episode: string
  source: string
  title: string
}

export interface LinesContextGroup {
  lines: (IndexedLine | typeof START_OF_EPISODE | typeof END_OF_EPISODE)[]
  matchedLines: string[]
  episode: string
}

export interface Results {
  lineGroups: LinesContextGroup[]
  episodes: Record<string, Episode>
  rawResult?: unknown[]
}

export const START_OF_EPISODE = 'start_of_episode'
export const END_OF_EPISODE = 'end_of_episode'

export const shows = {
  'brooklyn-nine-nine': 'Brooklyn Nine-Nine',
  'the-office': 'The Office',
  'new-girl': 'New Girl',
} as const

export type ShowKey = keyof typeof shows

export function isShowKey(key: string): key is ShowKey {
  return key in shows
}

export const showKeys = Object.keys(shows) as ShowKey[]
